<template>
  <div>
    <v-card color="blue-grey darken-2" v-if="this.isComponent('dgr-dash')">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 pa-5>
            <v-form ref="form" v-model="valid" lazy-validation>
              <template>
                <v-data-table
                  :key="componentKey"
                  :headers="headers"
                  :items="dataSet"
                  class="elevation-1"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td>
                      <v-text-field
                        :rules="generationRules"
                        label="Generation"
                        single-line
                        @change="update($event, props.item.id)"
                        :value="props.item.generation ? props.item.generation : 0"
                      ></v-text-field>
                    </td>
                  </template>
                </v-data-table>
              </template>

              <v-select v-model="remarks" :items="items" label="Remarks" class="remarks"></v-select>

              <v-btn color="success" @click="submit">Submit</v-btn>

              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <no-device v-else :message="subscriptionMessage"></no-device>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const momentTz = require('moment-timezone')
import DGRApi from '@/services/DGR'
const NoDevice = () => import('@/components/utility/NoDevice.vue')

export default {
  components: {
    NoDevice
  },
  data() {
    return {
      subscriptionMessage:
      'This feature is not applicable for your plant.',
      componentKey: 0,
      headers: [{
        text: 'Inverter',
        align: 'left',
        value: 'id'
      },
      {
        text: 'Generation(kWh)',
        value: 'generation',
        align: 'left'
      }
      ],
      dataSet: [],
      valid: true,
      generationRules: [
        v => !!v || 'Generation is required',
        v => /^\d+\.{0,1}\d{0,2}$/.test(v) || 'Generation must be a number'
      ],
      remarks: null,
      tempRemarks: null,
      items: [
        'Low Irradiation due to Cloudy Weather whole Day',
        'Low Irradiation due to Cloudy Weather in First half',
        'Low Irradiation due to Cloudy Weather in Second half',
        'Rain - full Day',
        'Rain in First half',
        'Rain in Second half',
        '33 KV Line Trip',
        '33 KV Line Shutdown',
        'Bay Side ME Fault - Feeder1',
        'Bay Side ME Fault - Feeder2',
        'Block A Inverter - 1 under Maintenance by ABB',
        'Block A Inverter - 2 under Maintenance by ABB',
        'Block B Inverter - 1 under Maintenance by ABB',
        'Block B Inverter - 2 under Maintenance by ABB',
        'Block C Inverter - 1 under Maintenance by ABB',
        'Block C Inverter - 2 under Maintenance by ABB',
        'Block D Inverter - 1 under Maintenance by ABB',
        'Block D Inverter - 2 under Maintenance by ABB',
        'Block E Inverter - 1 under Maintenance by ABB',
        'Block E Inverter - 2 under Maintenance by ABB',
        'Block A Transformer under Maintenance by Tesla',
        'Block B Transformer under Maintenance by Tesla',
        'Block C Transformer under Maintenance by Tesla',
        'Block D Transformer under Maintenance by Tesla',
        'Block E Transformer under Maintenance by Tesla',
        'Block A DO Fuse Fault',
        'Block B DO Fuse Fault',
        'Block C DO Fuse Fault',
        'Block D DO Fuse Fault',
        'Block E DO Fuse Fault',
        'Routine Maintenance ShutDown',
        'Preventive Maintenance ShutDown'
      ],
      updateList: {},
      selectedId: '',
      date: momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
    }
  },
  computed: {
    ...mapGetters([
      'getActivePlantTimezone',
      'getSelectedPlantId',
      'isComponent'
    ])
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      DGRApi.getGeneration(this.getSelectedPlantId, this.date).then(response => {
        if (response.status === 200) {
          this.dataSet = response.data.message
        }
      })

      DGRApi.getRemarks(this.getSelectedPlantId, this.date).then(res => {
        if (res.status === 200) {
          this.remarks = res.data.message.remarks
          this.tempRemarks = res.data.message.remarks
        }
      })
    },
    submit() {
      if (Object.keys(this.updateList).length) {
        let generationParam = {
          plantId: this.getSelectedPlantId,
          date: this.date,
          updateList: this.updateList
        }

        DGRApi.updateGeneration(generationParam).then(response => {
          console.log(response)
          if (response.status === 200) {
            console.log('Changes successful')
          } else {
            console.log('Change failed')
          }
        })
      }

      if (this.remarks) {
        let remarksParam = {
          plantId: this.getSelectedPlantId,
          date: this.date,
          remarks: this.remarks
        }

        DGRApi.updateRemarks(remarksParam).then(response => {
          console.log(response)
          if (response.status === 200) {
            console.log('Remarks Changes successful')
          } else {
            console.log('Remarks Changes failed')
          }
        })
      }
    },
    update(value, id) {
      this.updateList[id] = value
    },
    reset() {
      this.componentKey++
      this.remarks = this.tempRemarks
    }
  },
  watch: {
    getSelectedPlantId() {
      this.getData()
    }
  }
}
</script>

